import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

@createModule('ModalOverlay')
/**
 * modal-overlay module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */
export class ModalOverlay extends TerrificSpec {
	$ctx: Object;
	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		$(window).on('modalWindow:open', this._openModal.bind(this));
		$(window).on('modalWindow:close', this._closeModal.bind(this));

		$(this.$ctx).on('click', this._closeModal.bind(this));
		$(document).on('keyup', (ev: any) => {
			if (ev.key === 'Escape') {
				this._closeModal();
			}
		});

		resolve();
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}

	_openModal() {
		$(this.$ctx).addClass('state-m-modal-overlay--visible');
	}

	_closeModal() {
		$(this.$ctx).removeClass('state-m-modal-overlay--visible');
		$('html').removeClass('no-scrolling--without-scrollbar');
		$(this.$ctx).empty();
	}
}
